import { render, staticRenderFns } from "./ShopFirstDerate.vue?vue&type=template&id=04dadf10&scoped=true&"
import script from "./ShopFirstDerate.vue?vue&type=script&lang=js&"
export * from "./ShopFirstDerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dadf10",
  null
  
)

component.options.__file = "ShopFirstDerate.vue"
export default component.exports